import { gql } from '@apollo/client'

export default gql(`
mutation createLanguage($name: String!, $project: String) {
    createLanguage(
        input: {
            name: $name
        },
        project: $project
    ) {
        id
        name
        source
        assetCount
    }
}`
)
